var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusinessType(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "R052 - Work"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector Path",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.8 40.8V9.60001C40.8 8.28001 39.72 7.20001 38.4 7.20001H21.6C20.28 7.20001 19.2 8.28001 19.2 9.60001V21.6H9.60001C8.28001 21.6 7.20001 22.68 7.20001 24V40.8H40.8ZM9.60001 24H19.2V38.4H9.60001V24ZM38.4 9.60001H21.6V38.4H38.4V9.60001ZM28.8 14.4H24V16.8H28.8V14.4ZM36 14.4H31.2V16.8H36V14.4ZM24 21.6H28.8V24H24V21.6ZM36 21.6H31.2V24H36V21.6ZM24 28.8H28.8V31.2H24V28.8ZM16.8 28.8H12V31.2H16.8V28.8ZM31.2 28.8H36V31.2H31.2V28.8Z",
    fill: "#1287FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessType);
export default __webpack_public_path__ + "static/media/business-type.33b7c9b689afe3121691f9b980890f08.svg";
export { ForwardRef as ReactComponent };